export default __webpack_public_path__ + "static/media/customer-support-illustration.bc669664.svg";